import { getLocationQuery } from '@lib/routing';

export const getCurrentLanguage = (search: string) => {
  const language = getLocationQuery(search, 'language');

  return language || 'ru';
};
